
import { mapState } from 'vuex';
import ReviewContentType from '@/enums/ReviewContentType';
import FocusFirstNewReview from '@/mixins/FocusFirstNewReview';

export default {
  i18nComponentKey: 'WidgetReviewsListV3.components.Body',
  name: 'Body',
  emits: ['reported'],
  mixins: [FocusFirstNewReview],
  props: {
    reviews: {
      type: Array,
      required: true
    },
    popupParams: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('widget', ['widget']),
    bodyStyle() {
      return {
        '--min-height': this.widget.show_filter_section ? '204px' : 'auto'
      };
    }
  },
  methods: {
    displayMediaSection(review) {
      return (
        review.content_type !== ReviewContentType.RESTRICTED &&
        review.media_count > 0
      );
    }
  }
};
